import React, { createContext, useContext, useState, useEffect } from 'react';
import {
	defaultColDefination,
	formatPercentageToSingleDecimal,
	initialGridData,
} from 'CategoryManagement/Explore/DetailedAnalysis/utils';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import { getSignificantGrowthSuppliers } from 'utils/apiRequests';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import { formatNumber } from 'utils/number';

const SignificantYoyGrowthContext = createContext();

const suppliersText = 'suppliers';
const columnDefs = [
	{ headerName: 'Vendor Name', field: 'vendoR_NAME' },
	{ headerName: 'AP L1Category', field: 'aP_L1Category' },
	{ headerName: 'AP L2Category', field: 'aP_L2Category' },
	{ headerName: 'AP L3Category', field: 'aP_L3Category' },
	{ headerName: 'AP L4Category', field: 'aP_L4Category' },
	{ headerName: 'Business Unit', field: 'purchasinG_GROUP' },
	{ headerName: 'AP L4 Vendor Growth', field: 'spendGrowthVendor' },
	{
		headerName: 'AP L4Category Growth',
		field: 'spendGrowthAP_L4Category',
		sort: 'desc',
	},
];

export const SignificantYoyGrowthProvider = ({ children }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [analysis, setAnalysis] = useState(`X ${suppliersText}`);
	const [gridData, setGridData] = useState(initialGridData);
	const { currentSelectCategory, dateRangeData, isFetching } = useContext(
		CategoryManagementContext
	);
	const { loading: isSettingsFetching } = useContext(
		CategoryInsightsSettingsContext
	);
	const { categoryName } = currentSelectCategory;
	const { dateFrom, dateTo } = dateRangeData;

	useEffect(
		() => {
			if (!isSettingsFetching && !isFetching) {
				setIsLoading(true);
				if (
					categoryName !== '' ||
					categoryName !== null ||
					categoryName !== undefined
				) {
					const payLoad = {
						categoryName: categoryName,
						dateFrom: dateFrom,
						dateTo: dateTo,
					};
					getSignificantGrowthSuppliers(payLoad)
						.then(response => {
							if (response.succeeded) {
								if (response.data.length > 0 || response.data !== null) {
									if (!!Object.keys(response.data).length) {
										if (response.data.explore.length > 0) {
											const filteredResult = response.data.explore.filter(
												obj =>
													obj.spendGrowthVendor >= 0 &&
													obj.spendGrowthAP_L4Category >= 0
											);
											const rowResult = filteredResult.map(x => {
												return {
													...x,
													spendGrowthVendor: formatPercentageToSingleDecimal(
														x.spendGrowthVendor
													),
													spendGrowthAP_L4Category: formatPercentageToSingleDecimal(
														x.spendGrowthAP_L4Category
													),
												};
											});
											const analysisString = `${formatNumber(
												filteredResult.length
											)} ${suppliersText}`;
											setAnalysis(analysisString);
											setGridData(prevState => ({
												...prevState,
												rowData: rowResult,
												columnDefs: columnDefs,
												defaultColDef: defaultColDefination,
											}));
										} else {
											setGridData(initialGridData);
											setAnalysis(`0 ${suppliersText}`);
										}
										setIsLoading(false);
									}
								} else {
									setIsLoading(false);
								}
							} else {
								setIsLoading(false);
							}
						})
						.catch(() => setIsLoading(false));
				} else {
					setIsLoading(false);
				}
			}
		}, // eslint-disable-next-line
		[dateRangeData, categoryName, isSettingsFetching, isFetching]
	);

	return (
		<SignificantYoyGrowthContext.Provider
			value={{ isLoading, analysis, gridData }}
		>
			{children}
		</SignificantYoyGrowthContext.Provider>
	);
};

export const useSignificantYoyGrowthContext = () => {
	return useContext(SignificantYoyGrowthContext);
};
